import axios from "axios";

import MANAGER_API_ROUTES from "manager/config/apiRoutes";
import { API_URL } from "shared/lib/api/setupApi";
import { transformRoute } from "shared/utils/routing";

const api = {
  deleteCosignPropertyMapping: (cosignPropertyId: number | string) =>
    axios
      .delete(
        `${API_URL}${transformRoute(MANAGER_API_ROUTES.cosignProperty, {
          cosignPropertyId,
        })}`
      )
      .then((response) => response.data),
  updateCosignPropertyIsActive: (
    cosignPropertyId: number | string,
    isActive: boolean
  ) =>
    axios
      .patch(
        `${API_URL}${transformRoute(MANAGER_API_ROUTES.cosignProperty, {
          cosignPropertyId,
        })}`,
        { is_active: isActive }
      )
      .then((response) => response.data),
};

export default api;
